"use strict";

module.exports = {
  CAMPUS_EHS: 'CAMPUS_EHS',
  CAMPUS_HR: 'CAMPUS_HR',
  MEDICAL_CENTER_EHS: 'MEDICAL_CENTER_EHS',
  MEDICAL_CENTER_HR: 'MEDICAL_CENTER_HR',
  RISK_SERVICE: 'RISK_SERVICE'
};